<p-steps [model]="wizard.steps" [(activeIndex)]="wizard.currentStep"></p-steps>

<ng-container *ngIf="wizard.steps.length" [ngSwitch]="wizard.steps[wizard.currentStep].automationId">
  <ng-container *ngSwitchCase="AssignTrainingStepsEnum.Learners">
    <p translate>assign-training-wizard.learners-step.add-learner-info</p>
    <vnm-tile-card
      header="assign-training-wizard.learners-step.title"
      subheader="assign-training-wizard.learners-step.info"
    >
      <div class="p-actions-bar">
        <vnm-list-filter>
          <input
            type="search"
            pInputText
            vnmPlaceholder="assign-training-wizard.learners-step.learner-search-placeholder"
            (input)="table.filterGlobal($event.target.value, 'contains')"
          />
        </vnm-list-filter>
      </div>
      <p-table
        #table
        [value]="learners$ | async | dup"
        [autoLayout]="true"
        [responsive]="true"
        [paginator]="true"
        [rows]="25"
        loadingIcon="fas fa-spinner-third fa-spin"
        [globalFilterFields]="['fullName', 'email', 'mobileNumber']"
        selectionMode="multiple"
        [(selection)]="wizard.learners"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="selection-column"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
            <th translate>assign-training-wizard.learners-step.learner-title</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-learner>
          <tr [pSelectableRow]="learner">
            <td colspan="2">
              <div class="flex flex-column gap-xxs">
                <strong>{{ learner.fullName }}</strong>
                <vnm-user-contacts [user]="learner" [showIcons]="false" [enableLinks]="false"></vnm-user-contacts>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <vnm-table-empty-message
            icon="users-slash"
            message="assign-training-wizard.learners-step.no-learners"
            loadingMessage="assign-training-wizard.learners-step.loading-learners"
          >
            <vnm-sidebar-toggle
              #addLearnersToggle
              icon="fa fa-fw fa-plus"
              label="manage-learners.header.add-learners"
              buttonClass="p-button-secondary mt-3 w-auto"
            >
              <ng-template #toggle>
                <vnm-add-learners-wizard></vnm-add-learners-wizard>
              </ng-template>
            </vnm-sidebar-toggle>
          </vnm-table-empty-message>
        </ng-template>
      </p-table>
    </vnm-tile-card>
    <p-footer>
      <p-message
        @fade
        *ngIf="wizard.learners?.length"
        severity="info"
        [text]="
          'assign-training-wizard.learners-step.learners-selected' | translate: { learners: wizard.learners?.length }
        "
      ></p-message>
      <vnm-flex-container>
        <button
          pButton
          type="button"
          icon="fa fa-fw fa-times"
          class="p-button-secondary"
          [label]="'app.cancel' | translate"
          (click)="sidebarToggle.close()"
          flex-start
        ></button>
        <button
          pButton
          type="button"
          icon="fa fa-fw fa-angle-right"
          iconPos="right"
          [label]="
            (requiresTags
              ? 'assign-training-wizard.learners-step.set-tags'
              : 'assign-training-wizard.learners-step.choose-course'
            ) | translate
          "
          [disabled]="!wizard.learners.length"
          (click)="nextStep()"
          flex-end
        ></button>
      </vnm-flex-container>
    </p-footer>
  </ng-container>
  <ng-container *ngSwitchCase="AssignTrainingStepsEnum.Tags">
    <vnm-tile-card header="assign-training-wizard.tags-step.title" subheader="assign-training-wizard.tags-step.info">
      <p-card>
        <div [formGroup]="tagsForm">
          <ng-container formArrayName="tagItems">
            <div *ngFor="let tag of tagItems.controls; let i = index" class="p-col-12 p-md-4 wizard-tag-field mb-3">
              <ng-container *ngIf="!tag.value.custom; else customInput">
                <vnm-form-field [formGroup]="tag" [label]="tag.value.key">
                  <input type="text" pInputText formControlName="value" />
                </vnm-form-field>
              </ng-container>

              <ng-template #customInput>
                <vnm-form-field [formGroup]="tag" label="assign-training-wizard.tags-step.custom-field">
                  <input
                    type="text"
                    pInputText
                    formControlName="key"
                    [placeholder]="'assign-training-wizard.tags-step.placeholder-key' | translate"
                  />
                  <input
                    type="text"
                    pInputText
                    formControlName="value"
                    [placeholder]="'assign-training-wizard.tags-step.placeholder-value' | translate"
                  />
                  <button
                    pButton
                    type="button"
                    icon="fa fa-fw fa-times"
                    (click)="removeOption(i)"
                    class="p-button-danger p-button-text"
                  ></button>
                </vnm-form-field>
              </ng-template>
            </div>
          </ng-container>
        </div>

        <button
          pButton
          type="button"
          [label]="'assign-training-wizard.tags-step.add-custom' | translate"
          [icon]="'fa fa-fw fa-plus'"
          (click)="addOption()"
          class="p-button-secondary"
        ></button>
      </p-card>
    </vnm-tile-card>

    <p-footer>
      <vnm-flex-container>
        <button
          pButton
          type="button"
          icon="fa fa-fw fa-angle-left"
          [label]="'assign-training-wizard.learners-step.title' | translate"
          class="p-button-secondary"
          (click)="prevStep()"
          flex-start
        ></button>
        <button
          pButton
          type="button"
          icon="fa fa-fw fa-angle-right"
          iconPos="right"
          [label]="'assign-training-wizard.learners-step.choose-course' | translate"
          [disabled]="!tagsForm.valid"
          (click)="nextStep()"
          flex-end
        ></button>
      </vnm-flex-container>
    </p-footer>
  </ng-container>
  <ng-container *ngSwitchCase="AssignTrainingStepsEnum.Training">
    <vnm-tile-card
      header="assign-training-wizard.training-step.title"
      subheader="assign-training-wizard.training-step.info"
    >
      <div class="p-actions-bar">
        <vnm-list-filter>
          <input
            type="search"
            pInputText
            vnmPlaceholder="assign-training-wizard.course-search-placeholder"
            (input)="table.filterGlobal($event.target.value, 'contains')"
            class="flex-1"
          />
        </vnm-list-filter>
        <p-multiSelect
          [options]="ownerOptions"
          [ngModel]="selectedOwners"
          (onChange)="onFilterOwners($event)"
          [selectedItemsLabel]="'assign-training-wizard.training-step.x-owners' | translate"
          [placeholder]="'assign-training-wizard.training-step.choose-owners' | translate"
          optionLabel="name"
          optionValue="gid"
          styleClass="w-full"
          class="flex-1"
        ></p-multiSelect>
      </div>
      <p-table
        #table
        [value]="licenses || (licenses$ | async | dup)"
        [autoLayout]="true"
        [responsive]="true"
        [paginator]="true"
        [rows]="25"
        [globalFilterFields]="['course.name', 'owner.name']"
        [(selection)]="wizard.licenses"
        loadingIcon="fas fa-spinner-third fa-spin"
        selectionMode="multiple"
      >
        <ng-template pTemplate="header">
          <tr>
            <th></th>
            <th pSortableColumn="course.name" translate>
              assign-training-wizard.course-name
              <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th translate>assign-training-wizard.license-seats</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-license>
          <tr
            [pSelectableRow]="license"
            [ngClass]="{ 'selection-disabled': license.seats !== null && license.usedSeats === license.seats }"
          >
            <td class="media-cell">
              <img [attr.src]="license?.course?.photo?.url" [attr.alt]="license?.course?.name" />
            </td>
            <td>
              <div class="flex flex-column gap-xxs">
                <strong>{{ license.course.name }}</strong>
                <small [translateParams]="{ name: license.owner.name }" translate>
                  assign-training-wizard.training-step.course-owner
                </small>
                <vnm-badge
                  @fade
                  *ngIf="hasILCourse(license.course.courseItems)"
                  class="align-self-baseline gap-xxs"
                  translate
                >
                  assign-training-wizard.ilt-course
                  <vnm-help-tip [help]="'assign-training-wizard.training-step.ilt-help-tip' | translate"></vnm-help-tip>
                </vnm-badge>
              </div>
            </td>
            <td class="p-column-actions">{{ license.usedSeats }} / {{ license.seats | infinity }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <vnm-table-empty-message
            [loading]="(licenses$ | async) === null"
            loadingMessage="assign-training-wizard.training-step.loading-courses"
            message="assign-training-wizard.training-step.no-courses"
          >
            <button
              type="button"
              pButton
              [label]="'shopping-cart.browse-catalog' | translate"
              icon="fa fa-fw fa-search"
              class="mt-3"
              (click)="onBrowseCatalog()"
            ></button>
          </vnm-table-empty-message>
        </ng-template>
      </p-table>
    </vnm-tile-card>
    <p-footer>
      <p-messages [(value)]="trainingMessages" showTransitionOptions="0ms" hideTransitionOptions="0ms"></p-messages>
      <vnm-flex-container>
        <button
          pButton
          type="button"
          icon="fa fa-fw fa-angle-left"
          [label]="
            (requiresTags
              ? 'assign-training-wizard.learners-step.set-tags'
              : 'assign-training-wizard.learners-step.title'
            ) | translate
          "
          class="p-button-secondary"
          (click)="prevStep()"
          flex-start
        ></button>
        <button
          pButton
          type="button"
          icon="fa fa-fw fa-angle-right"
          iconPos="right"
          [label]="
            (hasILCourseSelection ? 'assign-training-wizard.book-classes' : 'assign-training-wizard.assign-training')
              | translate
          "
          (click)="nextStep()"
          [disabled]="!wizard.licenses.length"
          flex-end
        ></button>
      </vnm-flex-container>
    </p-footer>
  </ng-container>
  <ng-container *ngSwitchCase="AssignTrainingStepsEnum.Booking">
    <vnm-tile-card
      header="assign-training-wizard.booking-step.title"
      subheader="assign-training-wizard.booking-step.info"
    >
      <p-table
        #table
        [value]="wizard.licenses | ilLicenses"
        [autoLayout]="true"
        [responsive]="true"
        [paginator]="true"
        [rows]="25"
        loadingIcon="fas fa-spinner-third fa-spin"
        selectionMode="multiple"
        [(selection)]="wizard.bookings"
        rowGroupMode="subheader"
        groupRowsBy="gid"
        responsiveLayout="scroll"
        (onRowSelect)="onBookingSelect($event)"
      >
        <ng-template pTemplate="groupheader" let-license>
          <tr pRowGroupHeader>
            <td colspan="2">
              <img
                [attr.alt]="license?.course?.name"
                [attr.src]="license?.course?.photo?.url"
                width="32"
                style="vertical-align: middle"
                class="border-round"
              />
              <span class="font-bold ml-2">{{ license.course.name }}</span>
            </td>
            <td class="p-column-actions">
              <vnm-floated-label-field label="assign-training-wizard.training-step.modules">
                {{ countILBookingSelections(license) }} / {{ countILCourseItems(license?.course?.courseItems) }}
              </vnm-floated-label-field>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-license>
          <vnm-il-booking-table-row [license]="license"></vnm-il-booking-table-row>
        </ng-template>
      </p-table>
    </vnm-tile-card>
    <p-footer>
      <p-messages [(value)]="bookingMessages" showTransitionOptions="0ms" hideTransitionOptions="0ms"></p-messages>
      <vnm-flex-container>
        <button
          pButton
          type="button"
          icon="fa fa-fw fa-angle-left"
          [label]="'assign-training-wizard.training-step.title' | translate"
          class="p-button-secondary"
          (click)="prevStep()"
          flex-start
        ></button>
        <button
          pButton
          type="button"
          icon="fa fa-fw fa-angle-right"
          iconPos="right"
          [label]="
            (hasILBookingSelection ? 'assign-training-wizard.assign-training' : 'assign-training-wizard.skip')
              | translate
          "
          (click)="nextStep()"
          flex-end
        ></button>
      </vnm-flex-container>
    </p-footer>
  </ng-container>
  <ng-container *ngSwitchCase="AssignTrainingStepsEnum.Assign">
    <vnm-assign-training
      *ngFor="let assignment of wizard.assignments"
      [license]="assignment.license"
      [bookings]="assignment.bookings"
      [learners]="wizard.learners"
      [tags]="tagItems.value"
      (assigned)="onAssigned($event)"
      @fade
    ></vnm-assign-training>
    <p-footer>
      <vnm-flex-container>
        <button
          pButton
          type="button"
          icon="fa fa-fw fa-times"
          class="p-button-secondary"
          [label]="'app.close' | translate"
          (click)="sidebarToggle.close()"
          flex-start
        ></button>
      </vnm-flex-container>
    </p-footer>
  </ng-container>
  <p-toast [baseZIndex]="5000"></p-toast>
</ng-container>
